import { RefObject } from 'react';
import { gsap, ScrollTrigger, useGSAP, prefersReducedMotion } from '../../lib/gsap';

/**
 * Staggered rise-in for every `[data-reveal]` element inside `scope` as it enters the viewport.
 * Pass `deps` that change when async content renders so newly mounted items get picked up.
 */
export function useReveal(scope: RefObject<HTMLElement>, deps: unknown[] = []) {
   useGSAP(
      () => {
         const items = gsap.utils.toArray<HTMLElement>('[data-reveal]:not([data-revealed])');
         if (!items.length) return;
         items.forEach(el => el.setAttribute('data-revealed', ''));

         if (prefersReducedMotion()) return;

         gsap.set(items, { autoAlpha: 0, y: 48, clipPath: 'inset(0% 0% 18% 0%)' });
         ScrollTrigger.batch(items, {
            start: 'top 92%',
            once: true,
            onEnter: batch =>
               gsap.to(batch, {
                  autoAlpha: 1,
                  y: 0,
                  clipPath: 'inset(0% 0% 0% 0%)',
                  stagger: 0.08,
                  duration: 1.2,
                  overwrite: true,
               }),
         });
         ScrollTrigger.refresh();
      },
      { scope, dependencies: deps }
   );
}
